import {
  IconButton,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { MODAL, modalActions } from "redux/slices/modal";
import { useEffect, useState } from "react";
import QuotationService from "services/quotation.service";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { StyledTableCell, StyledTableRow } from "components/templates/Tables";
import TableLoadingWrapper from "components/templates/TableLoadingWrapper";
import DateService from "utils/date.util";
import { QuotationsListProps } from ".";
import Chip from "components/atoms/Chip";
import QuotationFilters from "../QuotationFilters";
import { quotationActions } from "redux/slices/quotation";
import { openPrivateFile } from "utils/openPrivateFile.util";
import DeleteIcon from "assets/delete.png";
import ModeEditIcon from "assets/edit.svg";
import SubscriptionService from "services/subscription.service";
import RequestQuoteIcon from "assets/download.png";
import MailIcon from "assets/send.png";



export default function QuotationsList({
  type,
  showFilters,
}: QuotationsListProps) {
  const dispatch = useAppDispatch();
  const refresh = useAppSelector((state) => state.quotation.refresh);
  const refreshLoader = useAppSelector(
    (state) => state.quotation.refreshLoader
  );
  const count = useAppSelector((state) => state.quotation[type].count);
  const loading = useAppSelector((state) => state.quotation[type].loading);
  const filters = useAppSelector((state) => state.quotation[type].filters);
  const quotations = useAppSelector(
    (state) => state.quotation[type].quotations
  );
  const navigate = useNavigate();

  const [query, setQuery] = useState("");

  useEffect(() => {
    return () => {
      dispatch(quotationActions.resetPage(type));
    };
  }, [dispatch, type]);

  useEffect(() => {
    const data = showFilters ? filters : null;
    QuotationService.getQuotations(type, data);
  }, [type, filters, refresh, showFilters, query]);

  return (
    <>
      {showFilters && (
        <QuotationFilters
          type={type}
          query={query}
          handleResetquery={() => setQuery("")}
        />
      )}

      <div className="pagination-list">
        <p>{count > 0 && `${count} quotation${count > 1 ? "s" : ""}`}</p>
        {showFilters && count > 0 && (
          <Pagination
            page={filters.page}
            disabled={refreshLoader}
            count={Math.ceil(count / filters.page_size)}
            onChange={(_e, page) =>
              dispatch(quotationActions.setPage({ type, page }))
            }
          />
        )}
      </div>

      <TableContainer>
        <Table
          sx={{
            minWidth: "100%",
            borderCollapse: "separate",
            borderBottomWidth: "0px",
            borderSpacing: "0 10px",
          }}
          aria-label="customized table"
        >
          <TableLoadingWrapper
            loading={loading}
            length={refreshLoader ? 0 : quotations?.length}
            coloumns={6}
            message={`We couldn't find any quotations`}
          >
            <TableHead>
              <TableRow>
                <StyledTableCell
                  style={{ cursor: "pointer" }}
                  onClick={() => setQuery(query === "" ? "?id=ticketID" : "")}
                >
                  ID
                </StyledTableCell>
                <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                  CreatedAt
                </StyledTableCell>
                <StyledTableCell>Company</StyledTableCell>
                <StyledTableCell>Class</StyledTableCell>
                <StyledTableCell>No. of Bookings</StyledTableCell>
                <StyledTableCell>Price</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell align="center">Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {quotations?.length > 0 &&
                quotations?.map((quotation: any, index: number) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>
                      <span
                        style={{
                          color: quotation.status === "close" ? "green" : "",
                        }}
                      >
                        {quotation.quotation_id}
                      </span>
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      {DateService.getServerDateString(quotation.createdAt)}
                      <br />
                      {DateService.getServerTimeString(quotation.createdAt)}
                    </StyledTableCell>
                    <StyledTableCell>
                      <>{quotation.company_name}</>
                      <br />
                      <>{quotation.company_email}</>
                    </StyledTableCell>

                    <StyledTableCell >
                     <div style={{width:"200px",overflowWrap: "break-word" }}>
                     {quotation.bookings
                        ?.map((booking: any) => booking.class_id?.name)
                        ?.join(", ")}
                     </div>
                    </StyledTableCell> 

                    <StyledTableCell>
                      {quotation.bookings?.length || 0}
                    </StyledTableCell>

                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      <b>SAR {quotation.total_price}</b>
                    </StyledTableCell>

                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      <Chip
                        status={quotation.status}
                        onClick={() => {
                          SubscriptionService.subscribe(() => {
                            QuotationService.updateStatus(
                              quotation._id,
                              type == "open" ? "close" : "open"
                            );
                          });
                          dispatch(
                            modalActions.openModal({
                              width: "500px",
                              type: MODAL.CONFIRMATION_FORM,
                              data: {
                                heading: "Update Status",
                                message:
                                  type == "open"
                                    ? "Do you really want to close this quotation?"
                                    : "Do you really want to open again this quotation?",
                              },
                            })
                          );
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Stack direction="row" justifyContent="flex-end">
                        {/* <Tooltip title="Send Email" placement="top">
                          <IconButton
                            sx={{ padding: "5px" }}
                            aria-label="send-email"
                            onClick={() => {
                              navigate(`/update-rfq/${quotation._id}`);
                            }}
                          >
                            <img src={MailIcon} alt="MailIcon"  width={25} height={25}/>
                          </IconButton>
                        </Tooltip> */}
                        <Tooltip title="Download Quotation" placement="top">
                          <IconButton
                            sx={{ padding: "5px" }}
                            aria-label="pdf"
                            onClick={() =>
                              openPrivateFile(quotation.link, "quotation")
                            }
                          >
                            <img src={RequestQuoteIcon} alt="MailIcon" width={20} height={20} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Edit" placement="top">
                          <IconButton
                            sx={{ padding: "5px" }}
                            aria-label="edit"
                            onClick={() => {
                              navigate(`/update-rfq/${quotation._id}`);
                            }}
                          >
                            <img src={ModeEditIcon} alt="ModeEditIcon"  width={20} height={20}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete" placement="top">
                          <IconButton
                             sx={{ padding: "5px" }}
                            aria-label="delete"
                            onClick={() => {
                              SubscriptionService.subscribe(() => {
                                QuotationService.deleteQuotation(
                                  quotation._id,
                                  type
                                );
                              });
                              dispatch(
                                modalActions.openModal({
                                  width: "500px",
                                  type: MODAL.CONFIRMATION_FORM,
                                  data: {
                                    heading: "Delete Quotation",
                                    message:
                                      "Do you really want to remove this quotation?",
                                  },
                                })
                              );
                            }}
                          >
                            <img src={DeleteIcon} alt="DeleteIcon"  width={20} height={20}/>
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </TableLoadingWrapper>
        </Table>
      </TableContainer>

      {showFilters && count > 0 && (
        <Pagination
          page={filters.page}
          disabled={refreshLoader}
          count={Math.ceil(count / filters.page_size)}
          onChange={(_e, page) =>
            dispatch(quotationActions.setPage({ type, page }))
          }
        />
      )}
    </>
  );
}
